import { BeltSyllabus } from './types';

export const blueBelt: BeltSyllabus = {
    id: 'blue',
    name: 'Blue Belt',
    color: '#0000ff',
    theoryUnder13: [],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Joong-Gun?',
                    answer: 'Joong-Gun is named after the patriot Ahn Joong Gun, who assassinated Hiro Bumi Ito, the first Japanese Governor-General of Korea, known as the man who played the leading part in the Japanese occupation of Korea. There are 32 movements in this pattern to represent Mr Ahn\'s age when he was executed at Lui-Shung prison in 1910.'
                },
                {
                    question: 'How many movements in Joong-Gun?',
                    answer: '32'
                },
                {
                    question: 'What is the diagram of Joong-Gun?',
                    answer: '/assets/diagrams/joong_gun_diagram.png',
                    isImage: true
                },
                {
                    question: 'What does the Blue Belt signify?',
                    answer: 'Blue signifies the Heaven, towards which the plant matures into a towering tree, as training in Taekwon-Do progresses.'
                },
                {
                    question: 'What is Slow Motion?',
                    answer: 'Techniques performed in Slow Motion (Noo-rin Tongjak) are simply performed slowly. The hands and feet move slowly and the breath is "drawn out". The reason for Slow Motion is to develop strength, technique, balance, breath control and timing.'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Rear Foot Stance', answer: 'Dwitbal Sogi' },
                { question: 'Upset Fingertip Low Thrust', answer: 'Dwijibun Sonkut Najundae Tulgi' },
                { question: 'W-Shape Block', answer: 'San Makgi' },
                { question: 'Palm Upward Block', answer: 'Sonbadak Ollyo Makgi' },
                { question: 'Angle Punch', answer: 'Giyokja Jirugi' },
                { question: 'Twin Fist Upset Punch', answer: 'Sang Joomok Dwijibo Jirugi' },
                { question: 'U-Shape Block', answer: 'Digutja Makgi' },
                { question: 'Reverse Knifehand Middle Block', answer: 'Sonkal Dung Ka-un-dae Makgi' },
                { question: 'Side Checking Kick', answer: 'Yop Cha Momchugi' },
                { question: 'Low Side Front Snap Kick', answer: 'Najundae Yop Ap Cha Busigi' },
                { question: 'Flying Side Kick', answer: 'Twimyo Yop Chagi' },
                { question: 'One-Step Sparring', answer: 'Ilbo Matsogi' },
                { question: 'Semi-Free Sparring', answer: 'Ban-Jayoo Matsogi' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'L Stance Inner Forearm Middle Block, Walking Stance Upset Fingertip Low Thrust',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Sitting Stance Outer Forearm W-Shape Block (Stamping Motion)',
                    answer: 'Forward X 4'
                },
                {
                    question: 'L Stance Low Knifehand Guarding Block, Walking Stance Circular Block',
                    answer: 'Forward X 4'
                },
                {
                    question: 'Side Checking Kick (Rear Leg), Side Piercing Kick (Consecutive Motion)',
                    answer: 'Forward X 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Left and Right Reverse Turning Kick',
                    answer: '1 Board'
                },
                {
                    question: 'Flying Side Piercing Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Yul-Gok',
                    answer: ' '
                },
                {
                    question: 'Joong-Gun',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'Guillotine Front and Rear',
                    answer: ' '
                },
                {
                    question: 'Straight Thrust Type Movement to the Chest / Stomach',
                    answer: ' '
                },
                {
                    question: 'Situational - Any Hand / Elbow / Knee / Kick / Foot Technique',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'One-Step Sparring',
                    answer: 'Any Hand / Elbow Technique (attacker)'
                },
                {
                    question: 'Three-Step Semi-Free Sparring',
                    answer: 'Both start in L Stance Guarding Block'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Progression from Previous Grading'
                }
            ]
        }
    ]
};
